import { render, staticRenderFns } from "./AddInterveneRecord.vue?vue&type=template&id=9475d87e&scoped=true"
import script from "./AddInterveneRecord.vue?vue&type=script&lang=js"
export * from "./AddInterveneRecord.vue?vue&type=script&lang=js"
import style0 from "./AddInterveneRecord.vue?vue&type=style&index=0&id=9475d87e&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9475d87e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9475d87e')) {
      api.createRecord('9475d87e', component.options)
    } else {
      api.reload('9475d87e', component.options)
    }
    module.hot.accept("./AddInterveneRecord.vue?vue&type=template&id=9475d87e&scoped=true", function () {
      api.rerender('9475d87e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CommonPage/PsyCounselAppointment/components/AddInterveneRecord.vue"
export default component.exports